/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

/* eslint-disable react/no-multi-comp */
/* global QuickTooltip */

import React from "react";
import Actions from "okpay/actions/Actions";
import Summary from "okpay/components/Summary";
import PurchaseButton from "okpay/components/PurchaseButton";
import CloseButton from "okpay/components/CloseButton";
import Str from "shared/components/Str";
import _str from "shared/util/_str";

import "./hasinfosummary.scss";

function __guard__(value, transform) {
	return typeof value !== "undefined" && value !== null
		? transform(value)
		: undefined;
}

class ChangeButton extends React.Component {
	_onClick = (e) => {
		return Actions.rejectBillingInfo();
	};

	render() {
		return (
			<button className="okpay-change" onClick={this._onClick}>
				{this.props.children}
			</button>
		);
	}
}

class HasInfoSummary extends React.Component {
	componentWillUnmount() {
		return typeof QuickTooltip !== "undefined" && QuickTooltip !== null
			? QuickTooltip.close()
			: undefined;
	}

	_submitForm = () => {
		if (this.props.isSuccessful || this.props.isSubmitting) {
			return;
		}

		return Actions.confirmPurchase(this.props);
	};

	render() {
		let billingSummary;
		const lastFour = __guard__(
			this.props.creditCard != null ? this.props.creditCard.info : undefined,
			(x) => x.lastFour,
		);
		const paypalEmail = __guard__(
			this.props.paypal != null ? this.props.paypal.agreement : undefined,
			(x1) => x1.email,
		);

		const tooltipParams = {
			"data-tooltip": _str("Change info"),
		};

		if (lastFour && !(paypalEmail && lastFour === "0000")) {
			billingSummary = (
				<span className="okpay-hasinfosummary-info">
					<Str>Card ending in</Str>
					<strong {...tooltipParams}>{lastFour}</strong>
				</span>
			);
		} else if (paypalEmail) {
			billingSummary = (
				<span className="okpay-hasinfosummary-info">
					<Str>PayPal</Str>: <strong {...tooltipParams}>{paypalEmail}</strong>
				</span>
			);
		}

		return (
			<div className="okpay-hasinfosummary okpay-matte">
				<CloseButton />
				<Summary {...this.props} optionsAfterTitle={true} />
				<div className="okpay-hasinfosummary-footer">
					<div className="okpay-hasinfosummary-left">
						<PurchaseButton
							billingType={this.props.billingType}
							selectedOption={this.props.selectedOption}
							onClick={this._submitForm}
							isSuccessful={this.props.isSuccessful}
							isSubmitting={this.props.isSubmitting}
							rightSide={React.createElement(
								"div",
								{ className: "okpay-hasinfosummary-right" },
								<ChangeButton>{billingSummary}</ChangeButton>,
							)}
						>
							<Str>Confirm Purchase</Str>
						</PurchaseButton>
					</div>
				</div>
			</div>
		);
	}
}

export default HasInfoSummary;



// WEBPACK FOOTER //
// ./src/reflux/okpay/components/HasInfoSummary.jsx